module.exports = __webpack_public_path__ + "img/patientflow-logo.471cd1e9.png";